module.exports = "/_next/static/images/a38da8c28ae3446f5804ad60e0a9d83d-icon-3.svg";